import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '../utils';
import { MenuWrapperItem } from '../types/MenuWrapperItem';

const MenuWrapperVariants = cva(`flex flex-nowrap bg-background-input`, {
  variants: {
    orientation: {
      horizontal: 'flex-row justify-end gap-sm',
      vertical: 'flex-col m-sm',
      sidebar: 'flex-col gap-2xs px-sm py-md'
    }
  },
  defaultVariants: {
    orientation: 'vertical'
  }
});

type MenuWrapperVariantProps = VariantProps<typeof MenuWrapperVariants>;

export interface MenuWrapperProps extends MenuWrapperVariantProps {
  className?: string;
  items: MenuWrapperItem[];
}

export const MenuWrapper = React.forwardRef<HTMLDivElement, MenuWrapperProps>(
  ({ className, items = [], orientation = 'vertical', ...props }, ref) => {
    return (
      <div {...props} className={cn(MenuWrapperVariants({ orientation }), className)} ref={ref}>
        {items.map((items, index) => (
          <div
            className={cn(
              items.bordered
                ? orientation === 'vertical' || orientation === 'sidebar'
                  ? 'border-t border-t-border-base'
                  : 'border-s border-s-border-base'
                : '',
              orientation === 'horizontal' || orientation === 'sidebar'
                ? ''
                : 'pt-sm pb-sm ps-sm pr-sm'
            )}
            key={index}
          >
            {items.item}
          </div>
        ))}
      </div>
    );
  }
);

MenuWrapper.displayName = 'MenuWrapper';
